export const environment = {
  production: false,
  uat: false,
  staging: true,
  development: false,
  environment: 'staging',
  baseUrl: 'https://stg-utility-api.tracwater.online',
  portalId: '69cb420dad0c413ed5c33c7a',
  selectedNode: ''
};
